// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import LoginPage from './LoginPage';
import RegistrationPage from './RegistrationPage';
import AdminUpdatePage from './AdminUpdatePage';
import MedicalRecordPage from './MedicalRecordPage'; // 👈 Import MedicalRecordPage
import { ThemeProvider } from './ThemeContext';
import './App.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegistrationPage />} />
          <Route path="/admin-update" element={<AdminUpdatePage />} />
          
          {/* 👇 New Route for Medical Record Page */}
          <Route path="/medical-record" element={<MedicalRecordPage />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);
